<template>
    <div class="process-line">
        <div class="step" :class="status >= -1?'active':''">
            <div class="circle">
                 <v-icon v-if="status >= -1">mdi-check</v-icon>
                 <v-icon v-else>mdi-clock</v-icon>
            </div>
            <div class="label" v-text="status >= -1?'ثبت':'لغو شده'"></div>
        </div>
        <div class="step" :class="status >= 10?'active':''">
            <div class="circle">
                 <v-icon v-if="status >= 10?'active':''">mdi-check</v-icon>
                 <v-icon v-else>mdi-clock</v-icon>
            </div>
            <div class="label">پرداخت/پردازش</div>
        </div>
        <div class="step" :class="status >= 20?'active':''">
            <div class="circle">
                <v-icon v-if="status >= 20?'active':''">mdi-check</v-icon>
                 <v-icon v-else>mdi-clock</v-icon>
            </div>
            <div class="label">آماده‌سازی</div>
        </div>
        <div class="step" v-if="Number.parseInt(order.order_type) == 3" :class="status >= 30?'active':''">
            <div class="circle">
                <v-icon v-if="status >= 30?'active':''">mdi-check</v-icon>
                 <v-icon v-else>mdi-clock</v-icon>
            </div>
            <div class="label">ارسال</div>
        </div>
        <div class="step" :class="status >= 40?'active':''">
            <div class="circle">
                <v-icon v-if="status >= 40?'active':''">mdi-check</v-icon>
                 <v-icon v-else>mdi-clock</v-icon>
            </div>
            <div class="label">تحویل</div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        order:{
            type:Object,
            default:null,
            required:true
        }
    },
    computed:{
      status(){
        return Number.parseInt(this.order.status);
      }
    }
    // data(){
    //     return{
    //         status:0,
    //     }
    // },
    // created(){
    //     this.status = Number.parseInt(this.order.status);
    // },

    

}
</script>
<style scoped>
    /* process-line */
    .process-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      max-width: 800px;
      margin: 0 auto;
      background: white;
      border-radius: 16px;
      padding: 20px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    }

    .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      position: relative;
    }

    .step:not(:first-child)::after {
      content: '';
      position: absolute;
      top: 20px;
      left: 50%;
      height: 4px;
      width: 100%;
      background: #ddd;
      z-index: 0;
    }
    .step.active:not(:first-child)::after {
      background: #4CAF50;
    }

    .circle {
      width: 40px;
      height: 40px;
      background: #ddd;
      border-radius: 50%;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .step.active .circle {
      background: #4CAF50;
    }

    .label {
      font-size: 13px;
      text-align: center;
      color: #555;
      white-space: nowrap;
    }

    @media (max-width: 600px) {
      /* .process-line {
        flex-direction: column;
        align-items: stretch;
      }
      .step {
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 16px;
      }
      .step::after {
        display: none;
      }
      .circle {
        margin-bottom: 0;
        margin-left: 10px;
      }
      .label {
        text-align: right;
      } */
      .label {
        font-size: 11px;
      }
    }
</style>